import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { staffApi, errMsg } from "@/lib/api";
import { PAY_STATUS, scheduleWhen, feeLabel } from "@/lib/journey";

const PAY_CLS = { Unpaid: "text-amber-700", Paid: "text-emerald-700", Free: "text-slate-500", Waived: "text-sky-700" };

export const JourneyRegistrations = ({ items, isAdmin, onChanged }) => {
  const setPay = async (r, payment_status) => {
    try { await staffApi().patch(`/journey/registrations/${r.id}`, { payment_status }); toast.success("Payment status updated"); onChanged(); } catch (e) { toast.error(errMsg(e)); }
  };
  const remove = async (r) => {
    if (!window.confirm(`Remove ${r.name}'s registration?`)) return;
    try { await staffApi().delete(`/journey/registrations/${r.id}`); onChanged(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!items.length) return <p className="rounded-2xl border border-dashed border-slate-300 bg-white p-8 text-center text-sm text-slate-400" data-testid="journey-registrations-empty">No registrations yet.</p>;
  return (
    <div className="space-y-2" data-testid="journey-registrations">
      {items.map((r) => (
        <div key={r.id} className="flex flex-wrap items-center gap-3 rounded-2xl border border-slate-200 bg-white p-4" data-testid={`journey-reg-${r.id}`}>
          <div className="min-w-0 flex-1 basis-60">
            <p className="font-medium text-slate-900">{r.name} <span className="text-sm font-normal text-slate-500">· {r.mobile} · {r.email}</span></p>
            <p className="text-xs text-slate-500">{r.class_title} · {scheduleWhen(r.schedule)} · {feeLabel(r.fee)}</p>
          </div>
          <Select value={r.payment_status} onValueChange={(v) => setPay(r, v)}>
            <SelectTrigger className={`w-32 bg-white font-medium ${PAY_CLS[r.payment_status]}`} data-testid={`journey-pay-${r.id}`}><SelectValue /></SelectTrigger>
            <SelectContent className="bg-white">{PAY_STATUS.map((p) => <SelectItem key={p} value={p}>{p}</SelectItem>)}</SelectContent>
          </Select>
          {isAdmin && <Button size="icon" variant="ghost" onClick={() => remove(r)} className="text-rose-500" data-testid={`journey-reg-delete-${r.id}`}><Trash2 className="h-4 w-4" /></Button>}
        </div>
      ))}
    </div>
  );
};
